import { gql } from "@apollo/client";

// 게시글 목록 조회
export const GET_COMMUNITY_POSTS = gql(`
  query GetCommunityPosts($offset: Int!, $limit: Int!) {
    communityPosts(offset: $offset, limit: $limit) {
      id
      content
      authorName
      authorId
      status
      createdAt
      updatedAt
      replyCount
      replies {
        id
        content
        isAdmin
        createdAt
      }
    }
  }
`);

// 게시글 상세 조회
export const GET_COMMUNITY_POST = gql(`
  query GetCommunityPost($id: ID!) {
    communityPost(id: $id) {
      id
      content
      authorName
      authorId
      status
      createdAt
      updatedAt
      replyCount
      replies {
        id
        content
        isAdmin
        createdAt
        updatedAt
      }
    }
  }
`);

// 게시글 작성
export const CREATE_COMMUNITY_POST = gql(`
  mutation CreateCommunityPost($input: CreatePostInput!) {
    createCommunityPost(input: $input) {
      id
      content
      authorName
      authorId
      status
      createdAt
      replyCount
    }
  }
`);

// 댓글/답변 작성
export const CREATE_COMMUNITY_REPLY = gql(`
  mutation CreateCommunityReply($input: CreateReplyInput!) {
    createCommunityReply(input: $input) {
      id
      content
      isAdmin
      createdAt
      post {
        id
        status
        replyCount
      }
    }
  }
`);

// 게시글 삭제
export const DELETE_COMMUNITY_POST = gql(`
  mutation DeleteCommunityPost($id: Int!) {
    deleteCommunityPost(id: $id) {
      ok
      error
    }
  }
`);
